import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const JOB_FUNCTION_DELETE_RESOURCE = "job-function" as const;
export const JOB_FUNCTION_DELETE_API_PATH = `/v1/${JOB_FUNCTION_DELETE_RESOURCE}/{uuid}` as const;

export type JobFunctionDeleteResponse =
  paths[typeof JOB_FUNCTION_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useJobFunctionDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<JobFunctionDeleteResponse, Error, { uuid: string; force?: boolean }>({
    mutationFn: async ({ uuid, force }) => {
      const response = await alphartisApiAxios.delete<JobFunctionDeleteResponse>(
        `/v1/${JOB_FUNCTION_DELETE_RESOURCE}/${uuid}`,
        { params: { force } },
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [JOB_FUNCTION_DELETE_RESOURCE],
      });
    },
  });
};
